import reducer from './reducers';

export { default as geonamesSagas } from './sagas';
export { default as geonamesActions } from './actions';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/geonames/index.js